import { FaHtml5, FaCss3, FaJs, FaReact, FaVuejs, FaSquarespace, FaPhp, FaMailchimp, FaWordpress, FaFigma } from "react-icons/fa";
import { SiCraftcms, SiMysql, SiSymfony, SiThreedotjs, SiNextdotjs, SiTailwindcss, SiAxios, SiLaravel, SiTower, SiMdx, SiWebpack, SiVite, SiLodash, SiJquery, SiGraphql, SiPostgresql, SiMongodb, SiGnubash, SiGit, SiGithub, SiGitlab, SiPlesk, SiNodedotjs, SiTypescript, SiSass, SiBlender, SiRollupdotjs } from "react-icons/si";
import { TbBrandFramerMotion, TbBrandAdobeAfterEffect, TbBrandAdobeIllustrator, TbBrandAdobeIndesign, TbBrandAdobeXd, TbBrandAdobePhotoshop } from "react-icons/tb";
import { RedaxoLogo, GsapLogo } from "@/components/Logos";
export const StackList: {
  frontend: string[];
  backend: string[];
  tools: string[];
  other: string[];
} = {
  frontend: ["Lodash", "HTML5", "PHP", "CSS3", "Tailwind CSS", "Next.js", "JavaScript", "React", "Vue.js", "Three JS", "Motion", "MDX", "SASS", "Gsap", "jQuery"],
  backend: ["Lodash", "Axios", "Next.js", "Node.js", "PHP", "MySQL", "PostgreSQL", "MongoDB", "GraphQL", "Plesk", "Symfony", "Laravel", "REDAXO CMS", "Craft CMS"],
  tools: ["TypeScript", "Webpack", "Vite JS", "Git", "Rollup", "Node.js", "Bash"],
  other: ["Figma", "Tower", "XD", "Blender", "Photoshop", "After Effects", "Illustrator", "InDesign", "MailChimp", "Wordpress", "Squarespace"]
};
export type Stack = keyof typeof StackList;
export const MapStackToIcon = (stack: string) => {
  switch (stack) {
    case "HTML5":
      return <FaHtml5 className="text-[#e34c26]" />;
    case "CSS3":
      return <FaCss3 className="text-[#264de4]" />;
    case "Tailwind CSS":
      return <SiTailwindcss className="text-[#38bdf8]" />;
    case "Next.js":
      return <SiNextdotjs className="text-white" />;
    case "Vite JS":
      return <SiVite className="text-[#646cff]" />;
    case "Gsap":
      return <GsapLogo className="text-[#FFFCE1]" />;
    case "Lodash":
      return <SiLodash className="text-[#3492ff]" />;
    case "jQuery":
      return <SiJquery className="text-[#0769ad]" />;
    case "JavaScript":
      return <FaJs className="text-[#f0db4f]" />;
    case "Axios":
      return <SiAxios className="text-[#0078d4]" />;
    case "Laravel":
      return <SiLaravel className="text-[#ff2d20]" />;
    case "Tower":
      return <SiTower className="text-[#f7f7f7]" />;
    case "React":
      return <FaReact className="text-[#58c4dc]" />;
    case "Vue.js":
      return <FaVuejs className="text-[#42b883]" />;
    case "Three JS":
      return <SiThreedotjs className="text-white" />;
    case "Motion":
      return <TbBrandFramerMotion className="text-[#fff312]" />;
    case "Squarespace":
      return <FaSquarespace className="text-white" />;
    case "PHP":
      return <FaPhp className="text-[#8892bf]" />;
    case "MDX":
      return <SiMdx className="text-[#f9ac00]" />;
    case "MailChimp":
      return <FaMailchimp className="text-white" />;
    case "MySQL":
      return <SiMysql className="text-[#e97b00]" />;
    case "Symfony":
      return <SiSymfony className="text-white" />;
    case "REDAXO CMS":
      return <RedaxoLogo className="text-[#5b98d7]" />;
    case "Wordpress":
      return <FaWordpress className="text-white" />;
    case "Webpack":
      return <SiWebpack className="text-[#8dd6f9]" />;
    case "Figma":
      return <FaFigma className="text-[#f24e1e]" />;
    case "XD":
      return <TbBrandAdobeXd className="text-[#ff41c8]" />;
    case "Photoshop":
      return <TbBrandAdobePhotoshop className="text-[#31A8FF]" />;
    case "After Effects":
      return <TbBrandAdobeAfterEffect className="text-[#D291FF]" />;
    case "Illustrator":
      return <TbBrandAdobeIllustrator className="text-[#FF9A00]" />;
    case "InDesign":
      return <TbBrandAdobeIndesign className="text-[#FF3366]" />;
    case "Craft CMS":
      return <SiCraftcms className="text-[#E5422B]" />;
    case "GraphQL":
      return <SiGraphql className="text-[#e10098]" />;
    case "PostgreSQL":
      return <SiPostgresql className="text-[#336791]" />;
    case "MongoDB":
      return <SiMongodb className="text-[#47a248]" />;
    case "Bash":
      return <SiGnubash className="text-white" />;
    case "Git":
      return <SiGit className="text-[#f34f29]" />;
    case "GitHub":
      return <SiGithub className="text-white/80" />;
    case "GitLab":
      return <SiGitlab className="text-[#fca326]" />;
    case "Plesk":
      return <SiPlesk className="text-[#394b9e]" />;
    case "Node.js":
      return <SiNodedotjs className="text-[#68a063]" />;
    case "TypeScript":
      return <SiTypescript className="text-[#007acc]" />;
    case "SASS":
      return <SiSass className="text-[#cc6699]" />;
    case "Blender":
      return <SiBlender className="text-[#f5792a]" />;
    case "Rollup":
      return <SiRollupdotjs className="text-[#ec4a3f]" />;
    default:
      return <div>{stack}</div>;
  }
};